angular.module('ShoppingCartApp', [])
    .directive('shoppingCart', ['$http', function ($http) {
        return {
            restrict: 'E',
            scope: {
                cart: "=?",
                user: "=?"
            },
            template: '<div id="shopping-cart-wrapper" data-count="{{ cartCount() }}" ng-show="user.loggedIn || items.length">' +
            '    <div class="cart-toggle clickable hidden-desktop extra-arrow" ng-click="toggleCart()" ng-class="{open: cartOpen}">' +
            '        <span class="icon-cart {{getCartIcon()}}" data-count="{{ cartCount() }}"></span>' +
            '    </div>' +
            '    <div class="cart-toggle clickable hidden-mobile" ng-click="toggleCart()">' +
            '        <a aria-label="Go to cart" title="Go to cart" href="javascript:;" class="icon-cart {{getCartIcon()}}" ng-click="gotoCart()" data-count="{{ cartCount() }}"></a>' +
            '    </div>' +
            '    <div class="shopping-cart-dropdown" ng-class="{open: cartOpen}">' +
            '        <div aria-role="heading" class="p0 pb10 mr15 m0 fz16 font-pnbold">YOUR CART<span ng-show="cartCount() > 0"> ({{ cartCount() }})</span></div>' +
            '        <div class="cart-items" ng-show="items.length > 0">' +
            '           <ul class="cart-item-list">' +
            '               <li ng-repeat="item in items" class="cart-item {{items.length === 1 ? \'no-border-bottom\': \'\' }}">' +
            '                   <div class="cart-item-image">' +
            '                       <img ng-src="https://images.fivefourclub.com/images.fivefourclub.com/images/resized_images/500_500_{{ item.img }}" class="img-responsive" alt="{{ item.title }}" />' +
            '                   </div>' +
            '                   <div class="cart-item-detail">' +
            '                       <div class="mb10 caps cart-item">{{ item.title }}</div>' +
            '                       <div class="mb10 caps cart-item">Size: {{ item.size }}</div>' +
            '                       <div class="mb10 caps cart-item">Color: {{ item.color }}</div>' +
            '                       <div class="mb10 caps cart-item"><span class="{{item.isProdSale ? \'striketrough-gray\' : user.isMember ? \'striketrough-gray\' : \'hidden\'}}">{{ (user.isMember ? item.price_compareat : item.price_compareat) | currency }}</span><span class="{{item.isProdSale ? \'cart-item-sale\' : (user.isMember ? \'cart-item-member\' : \'cart-item-nonmember\')}}">{{ item.price | currency }}</span></div>' +
            '                       <div class="mb10 caps cart-item" ng-show="item.price == 0 && item.free_prod_msg == \'\'">FREE ITEM</div>' +
            '                       <div class="mb10 caps cart-item hidden" ng-show="item.price == 0 && item.free_prod_msg != \'\'">{{ item.free_prod_msg }}</div>' +
            '                       <label for="quantity-for-{{item.product_detail_id}}" class="cart-item-quantity" style="width: 50px; margin-bottom: 0;">' +
            '                           <select id="quantity-for-{{item.product_detail_id}}" class="form-control pick-size" ng-change="updateItem(item)" ng-model="item.quantity" ng-options="quantity for quantity in item.quantityOptions track by quantity">' +
            '                           </select>' +
            '                       </label>' +
            '                 </div>' +
            '                   <div class="pull-right">' +
            '                       <button ng-click="removeItem(item)" style="" class="remove-button">X</button>' +
            '                   </div>' +
            '               </li>' +
            '           </ul>' +
            '        </div>' +
            '       <div class="empty-cart p30 text-center" ng-show="! items.length">' +
            '           <span class="font-pnbold mt40 mb30">Your cart is empty</span>' +
            '       </div>' +
            '        <div class="pr15 cart-footer">' +
            '            <div class="row pt10">' +
            '               <div class="col-xs-4 mt5"><div class="cart-subtotal"><div class="mb5 fz14">SUBTOTAL: </div><div class="pull-left text-bold">${{ subTotal() }}</div></div></div>' +
            '               <div class="col-xs-8 mt5"><a aria-label="Go to cart" title="Go to cart" href="javascript:;" ng-click="gotoCart()" class="btn-block btn-black btn-checkout">{{items.length === 0 ? "START SHOPPING" : "VIEW CART"}}</a></div>' +
            '            </div>' +
            '        </div>' +
            '    </div>' +
            '</div>',
            controller: function ($scope, $timeout) {

                $scope.items = [];
                $scope.cartOpen = false;
                $scope.discount = 0;
                $scope.init = function () {
                    //$scope.getDiscount();
                    $scope.items = JSON.parse(JSON.stringify($scope.cart));
                    $scope.refreshCart(false);

                    window.addEventListener('shopping-cart-updated', function (e) {
                        var showCart = e.detail === 'show-cart';
                        $scope.refreshCart(showCart);
                    }, false);
                };

                $scope.refreshCart = function (showCart) {
                    //$scope.discount = $scope.getDiscount();
                    $http.get(BAG_URL).then(function (response) {
                        if (response.data && response.data.data) {
                            response.data = response.data.data;
                        }
                        $scope.items = response.data.bagItems;

                        if (showCart) {
                            $scope.showCart(3000);
                        }
                    }, function (response) {
                        // fail
                    });
                };

                $scope.showCart = function (milliseconds) {
                  //milliseconds = 99999999;
                    $scope.cartOpen = true;
                    $timeout(function () {
                        $scope.cartOpen = false;
                    }, milliseconds);
                }

                $scope.cartCount = function () {
                    return _.reduce(this.items, function (carry, item, key) {
                        carry += parseInt(item.quantity);

                        return carry;
                    }, 0);

                    return _.sumBy(this.items, 'quantity')
                };

                $scope.buildPriceUI = function (item) {
                  var priceTemplate =
                    '<div class="mb10 caps cart-item">' +
                    ' <span class="{{user.isMember ? \'striketrough-gray\' : \'\' }}">{{ item.price_msrp | currency }}</span>' +
                    ' <span ng-if="user.isMember" class="{{item.isProdSale ? \'cart-item-sale\' : \'cart-item-member\'}}">{{ item.price | currency }}</span>' +
                    '</div>' +
                    '<div class="mb10 caps cart-item" ng-show="item.price == 0 && item.free_prod_msg == \'\'">FREE ITEM</div>' +
                    '<div class="mb10 caps cart-item" ng-show="item.price == 0 && item.free_prod_msg != \'\'">{{ item.free_prod_msg }}</div>';
                  return priceTemplate;
                };

                $scope.removeItem = function (item) {
                    item.quantity = 0;
                    $scope.updateItem(item);
                };

                $scope.updateItem = function (item) {
                    var params = {
                        relative: false,
                        productDetailId: item.product_detail_id,
                        quantity: item.quantity
                    };
                    $http.post(BAG_UPDATE_URL, params)
                        .then(function (response) {
                            $scope.refreshCart();
                        }, function (response) {
                            // failbowl
                        });
                };

                $scope.toggleCart = function () {
                    $scope.cartOpen = ! $scope.cartOpen;
                    FiveFour.postMessage(
                      FiveFour.Events.StoreCartPreviewClicked,
                      {
                        cart_items:  $scope.items,
                        user_id: (dataLayer.length > 0 && dataLayer[0].userId != null ? dataLayer[0].userId : '-1')
                      }
                    );
                    //console.log('Fired event:' + FiveFour.Events.StoreCartPreviewClicked);
                };

              $scope.gotoCart = function () {
                FiveFour.postMessage(
                  FiveFour.Events.StoreCartGotoCartClicked,
                  {
                    cart_items:  $scope.items,
                    user_id: (dataLayer.length > 0 && dataLayer[0].userId != null ? dataLayer[0].userId : '-1')
                  }
                );
                //console.log('Fired event:' + FiveFour.Events.StoreCartGotoCartClicked);
                $timeout(function () {
                  window.location.href = '/cart';
                },50);
              };

                $scope.getCartIcon = function () {
                  var retval = ($scope.cartCount() > 0 ? 'full' : 'empty');
                  var extraClass = '';
                  switch ($scope.cartCount())
                  {
                  case 0:
                    extraClass = ' cart-items-zero';
                    break;
                  case 1:
                    extraClass = ' cart-items-one';
                    break;
                  case 2:
                  case 3:
                  case 4:
                  case 5:
                  case 6:
                  case 7:
                  case 8:
                  case 9:
                    extraClass = ' cart-items-two-p';
                      break;
                  case 10:
                    extraClass = ' cart-items-ten';
                    break;
                  case 11:
                    extraClass = ' cart-items-eleven';
                    break;
                  case 12:
                    extraClass = ' cart-items-twelve';
                    break;
                  case 13:
                  case 14:
                  case 15:
                  case 16:
                  case 17:
                  case 18:
                  case 19:
                    extraClass = ' cart-items-twelve-p';
                    break;
                  case 20:
                  case 21:
                  case 22:
                  case 23:
                  case 24:
                  case 25:
                    extraClass = ' cart-items-twenty-p';
                    break;
                  default:
                    extraClass = ' cart-items-twenty-p';
                  }
                  return retval + extraClass;
                };

                $scope.subTotal = function () {
                    var subTotal = _.reduce($scope.items, function (carry, item) {
                        carry += item.quantity * item.price;
                        return carry;
                    }, 0).toFixed(2);
                    subTotal = subTotal;
                    if (typeof $scope.discount == 'undefined') {
                      $scope.discount = 0.00;
                    }
                    return subTotal;
                };

              $scope.getDiscount = function () {
                var params = {
                  method : 'getOrder',
                  promoCode: FiveFour.readCookie('ffcartcoupon')
                };
                $http.post(CHECKOUT_SERVER_URL,params).then(function (response) {
                    if (response.data && response.data.data) {
                        response.data = response.data.data;
                    }
                  $scope.discount = response.data.pricing.promoDiscount;
                }, function (response) {
                  $scope.discount = 0.00;
                });
              };

                $scope.init();
            },
            link: function ($scope, element, attrs) {

            }
        };
    }]);

angular.bootstrap(document.getElementById('shopping-cart'), ['ShoppingCartApp']);
